import CONST from '../../../../includes/primitives/_constant_kaskida'
export default {
  data: () => ({

    HOST: CONST.HOST_NAME_RESOURCE + '/resources',
    rawData:  null,
    
    keys:     null,
    filters:  null,

    canvasForms:  null,

    cbData: null,

  }),


  
  computed: {
    ready2draw() {
      return (
        // this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },



  methods: {
    
    app_Colors() {
      this.gmx_ColorH2Sets()
      this.gmx_ColorV2Sets()

      let filter = this.svg.append('defs')
      .append('filter').attr('id', 'dropShadow')

      filter.append('feGaussianBlur') .attr('in', 'SourceAlpha').attr('stdDeviation', 5).attr('result', 'blur')
      filter.append('feOffset').attr('in', 'blur').attr('dx', 2).attr('dy', 2).attr('result', 'offsetBlur')

      let feMerge1 = filter.append('feMerge')
      feMerge1.append('feMergeNode').attr('in', 'offsetBlur')
      feMerge1.append('feMergeNode').attr('in', 'SourceGraphic')

       let message = this.svg.append('defs')
      .append('filter').attr('id', 'msgShadow')

      message.append('feGaussianBlur') .attr('in', 'SourceAlpha').attr('stdDeviation', 3).attr('result', 'blur')
      message.append('feOffset').attr('in', 'blur').attr('dx', .5).attr('dy', .5).attr('result', 'offsetBlur')

      let feMerge2 = message.append('feMerge')
      feMerge2.append('feMergeNode').attr('in', 'offsetBlur')
      feMerge2.append('feMergeNode').attr('in', 'SourceGraphic')
    },

    // LightGray:    
    // Gray:         
    // DarkGray:     
    // Yellow:       
    // Gold:         
    // Orange:       
    // Pink:         
    // Violet:       
    // Red:          
    // Thistle:      
    // Purple:       
    // Indigo:       
    // LightBlue:    
    // SkyBlue:      
    // SteelBlue:    
    // YellowGreen:  
    // DarkGreen:    

  }


}